// src/pages/returns/Returns.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import ReturnsTable from "../../components/returns/ReturnsTable";

const Returns = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ReturnsTable />
        </WrapperSection>
    );
};

export default Returns;
